import type { DocumentType } from '@/api'
import type { BadgeTone } from '@/theme/badge-tokens'
import type { BadgeSize } from './Badge'

const BADGE_TONES: BadgeTone[] = [
  'neutral',
  'green',
  'warn',
  'danger',
  'blue',
  'violet',
  'required',
]

const isBadgeTone = (value: string): value is BadgeTone =>
  (BADGE_TONES as string[]).includes(value)

const DOCUMENT_TYPE_TONE_MAP: Record<string, BadgeTone> = {
  'commercial-invoice': 'green',
  'electronic-accompanying-document': 'green',
  'export-accompanying-document': 'green',
  'packing-list': 'blue',
  'delivery-note': 'blue',
  'bill-of-lading': 'violet',
  waybill: 'violet',
  'sea-waybill': 'blue',
  'flight-letter': 'blue',
  'road-document': 'warn',
  'multimodal-doc': 'warn',
  MT700: 'danger',
  'weight-note': 'neutral',
  'exchange-bill': 'neutral',
  'origin-certif': 'green',
  'insurance-policy': 'violet',
  'customs-instructions': 'warn',
  'hscodes-list': 'neutral',
  'single-administrative-document': 'neutral',
  conversation: 'neutral',
  email: 'neutral',
  flux: 'blue',
  'setting-keys': 'neutral',
}

export const chipSizeToBadgeSize = (
  size?: 'small' | 'medium'
): BadgeSize => (size === 'medium' ? 'lg' : 'md')

export const documentTypeToBadgeTone = (
  documentType?: DocumentType
): BadgeTone => {
  const color = documentType?.color?.trim().toLowerCase()
  if (color && isBadgeTone(color)) return color

  const name = documentType?.name?.trim().toLowerCase()
  if (name && DOCUMENT_TYPE_TONE_MAP[name]) return DOCUMENT_TYPE_TONE_MAP[name]

  if (documentType?.role === 'lead') return 'green'
  if (documentType?.role === 'secondary') return 'blue'

  return 'blue'
}

export const exportTypeToBadgeTone = (exportType?: string): BadgeTone => {
  if (!exportType) return 'neutral'

  const key = exportType.toLowerCase()
  if (key.includes('import')) return 'green'
  if (key.includes('export')) return 'blue'
  if (key.includes('transit')) return 'warn'

  return 'neutral'
}

export const displayChipIconSx = {
  fontSize: 12,
  width: 12,
  height: 12,
  color: 'inherit',
  flexShrink: 0,
}
